import { Components } from '@mui/material/styles';
import { getFlowCssBaselineRoot } from '../themeProvider/baseline.theme';
import { BreakpointsOptions, Theme } from '@mui/material';

export const getFlowModal = (breakpointsOptions: BreakpointsOptions, rtl: boolean): Components<Theme>['MuiModal'] => ({
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => [
      getFlowCssBaselineRoot(true, breakpointsOptions, rtl, theme),
      {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& .modal-container': {
          borderRadius: '8px',
          position: 'relative',
          overflow: 'hidden',
          background: theme.palette.background.primary,
          margin: '32px 24px',
          width: '100%',
          boxShadow: '0px 24px 64px rgba(0, 0, 0, 0.15)',
          '& > button': {
            padding: '4px',
            top: '14px',
            right: '18px',
            position: 'absolute',
            background: 'transparent',
            border: '0px',
            cursor: 'pointer',
            '& > .ballotx': {
              fontSize: '26px',
              display: 'inline',
            },
          },
        },
      },
    ],
  },
});
